import styles from './BusyTooltip.module.css';
import { useMemo } from 'react';
import { useTranslate } from '../../../../../hooks/useTranslate';
import { Tooltip } from '../../../../widgets/Tooltip/Tooltip';

function datesOverlap(d1Start: Date, d1End: Date, d2Start: Date, d2End: Date): boolean {
    return (
        Math.max(d1Start.getTime(), d2Start.getTime()) < Math.min(d1End.getTime(), d2End.getTime())
    );
}
export function BusyTooltip({
    startDate,
    endDate,
    events
}: {
    startDate?: Date;
    endDate?: Date;
    events: { startDate: Date; endDate: Date }[];
}) {
    const busy = !!(
        startDate &&
        endDate &&
        events &&
        events.find((e) => datesOverlap(startDate, endDate, e.startDate, e.endDate))
    );

    const { t, locale } = useTranslate();
    const dates = useMemo(
        () =>
            events
                .map(
                    (e) => `${e.startDate.toLocaleString(locale, {
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit'
                    })}
                            &nbsp;-&nbsp;
                            ${e.endDate.toLocaleString(locale, {
                                year: 'numeric',
                                month: 'short',
                                day: '2-digit',
                                hour: '2-digit',
                                minute: '2-digit'
                            })}`
                )
                .filter((e, i, arr) => arr.indexOf(e) === i),
        [events]
    );
    if (!busy) return null;

    const firstDate = dates[0];
    const lastDate = dates.length > 1 ? dates[dates.length - 1] : undefined;

    return (
        <Tooltip
            content={
                <ul>
                    <li dangerouslySetInnerHTML={{ __html: firstDate }} />
                    {dates.length > 2 && (
                        <li>
                            {dates.length - 2} {t('other event(s)')}
                        </li>
                    )}
                    {lastDate && <li dangerouslySetInnerHTML={{ __html: lastDate }} />}
                </ul>
            }
            className={styles.busy}
        />
    );
}
